var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[(_vm.isLoaded && _vm.focusedClient)?_c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('DiaryEntries')],1):(!_vm.isLoaded && _vm.focusedClient)?_c('div',{staticStyle:{"height":"100%"}},[_c('DiarySkeleton')],1):_c('EmptyState',{attrs:{"message":"Kein Klient ausgewählt."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }